// src/App.js

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LoadingProvider } from './contexts/LoadingContext';
import LoadingOverlay from './components/common/LoadingOverlay';
import AppRoutes from './routes/AppRoutes';
import './styles/global.css';

const App = () => (
  <BrowserRouter>
    <LoadingProvider>
      <AuthProvider>
        <LoadingOverlay />
        <AppRoutes />
      </AuthProvider>
    </LoadingProvider>
  </BrowserRouter>
);

export default App;
